<template>
    <section class="app-main">

        <el-tabs type="border-card" v-model="tab">

            <el-tab-pane name="list" label="选择订货商品">
                <div class="app-main">
                    <div class="top-bar">
                        <el-input v-model="value" placeholder="查找订货商品" prefix-icon="el-icon-search" @change="getGoods" style="width:200px" clearable></el-input>
                        <el-button type="primary" @click="next"  style="width:120px;;margin-left:20px;">选中添加商品</el-button>
                    </div>
                    <el-card shadow="hover">
                        <el-table  :data="tableData"  @selection-change="selectGoods" style="width: 100%;" height="530" width="70" >
                            <el-table-column align="center" type="selection" width="60"> </el-table-column>
                            <el-table-column prop="order_id" align="center" label="商品ID" > </el-table-column>
                            <el-table-column prop="barcode"  align="center" label="条形码" > </el-table-column>
                            <el-table-column label="图片"  width="150" align="center">
                                <template slot-scope="scope">
                                   <table-img :src="scope.row.purchase_pic_url"></table-img>
                                </template>
                            </el-table-column>
                            <el-table-column prop="purchase_title" align="center"  label="商品名称"></el-table-column>
                            <el-table-column prop="attr_symbol_string"  align="center"  label="规格属性">   </el-table-column>       
                            <!-- <el-table-column prop="price"   align="center"  label="价格">   </el-table-column>        -->
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>

            <el-tab-pane name="add" label="完善商品信息">
                <add :name.sync="title" :belongs.sync="belongs" :skuItems.sync="skuItems" :skuAttr.sync="skuAttr" @success="tab = 'list'" />
            </el-tab-pane>
        </el-tabs>
            
        
    </section>
</template>
<script>
import { buy_list } from '@/api/goods.js'
import tableImg from '@/components/Image.vue'
import Add from './add-components'
export default {
    name:'buyUpload',
    components:{ Add, tableImg },
    data () {
        return {
            tab: 'list',
            value: '',
            tableData: [],
            title: '',
            skuItems: [],
            skuAttr: [],
            belongs: ''
        }
    },
    methods:{

        // 查找订货商品
        getGoods(){
            if(this.value == ""){
                this.tableData = [];
                return false
            }
            buy_list({title: this.value}).then(res => {
                if(res) {
                    this.tableData = res.data
                }
            })
        },


        // 选中需要添加的商品
        selectGoods(rows){
            let ids =  [], skuItems = [], skuAttr = []
            rows.forEach(e => {
                ids.push(e.order_id)
                let obj = { attr_val: [],barcode: e.barcode, str: e.attr_symbol_string, proxy_price:'',price:'',pre_sale_price:'',stock:'0',goods_weight:e.weight,goods_length:e.length,goods_width:e.width,goods_height:e.height,skupic:{url:'',pic_id:''} };
                e.attr_symbol_arr.forEach(ele => {
                    let attr = {
                        spec_id:ele.spec_id,
                        attr_title:ele.attr_title
                    }
                    obj.attr_val.push(ele.attr_title)
                    skuAttr.push(attr);
                })
                skuItems.push(obj)
            })
            if (this.tableData && this.tableData.length > 0) {
                if(Array.from(new Set(ids)).length != 1){
                this.$message.error('Error, 只能选中同一个商品的规格进行添加')
                return false
                }else {
                    this.title    = rows[0].purchase_title
                    this.belongs = rows[0].belongs
                    this.skuItems = skuItems
                    this.skuAttr  = skuAttr
                }
            }
        },

        // 选中订货商品、 跳转下一步：添加
        next() {
            if(this.skuItems.length == 0 || this.skuAttr.length == 0) {
                this.$message.error('Error, 最少需要选中一个进行添加')
                return false
            }else {
                this.tab = 'add'
            }
            
        }
    },
    activated() {
        this.value = '';
        this.tableData = [];
        // this.getGoods();
    }
    
}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .tips {
        color: #909399;
        font-size: 14px;
    }
    
    .sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
}
</style>

